import { Card, Col, Container, Form, Row } from 'react-bootstrap';
import {
  RHFControl,
  RHFDatePicker,
  RHFPhotoUploadCards,
  RHFSelect
} from 'components/common/form';
import PropTypes from 'prop-types';
import { genderOptions } from 'data/options/common';

const beneficiaryCategoryOptions = [
  { label: 'Child', value: 'Child' },
  { label: 'Widow', value: 'Widow' },
  { label: 'Student', value: 'Student' },
  { label: 'Family', value: 'Family' },
  { label: 'Medical Case', value: 'Medical Case' },
  { label: 'Other', value: 'Other' }
];

export const ProfileInformation = ({ sectionRef, sideNavLink }) => {
  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <Card.Title className="" as="h5">
          Profile Information
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Container className="px-0 d-flex flex-column gap-3">
          <RHFPhotoUploadCards name="image" label="Beneficiary Photo" />
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="firstName" label="First Name" required />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="middleName" label="Middle Name" />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="lastName" label="Last Name" required />
            </Col>
          </Row>
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFSelect
                name="gender"
                label="Gender"
                required
                options={genderOptions}
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFDatePicker
                name="dateOfBirth"
                label="Date of Birth"
                required
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Form.Label>Age</Form.Label>
              <RHFControl name="age" disabled />
            </Col>
          </Row>
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFSelect
                name="beneficiaryCategory"
                label="Beneficiary Category"
                options={beneficiaryCategoryOptions}
                required
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl
                name="beneficiaryCode"
                label="Beneficiary Code"
                disabled
                helpText="Auto-generated on save"
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFDatePicker
                name="enrollmentDate"
                label="Enrollment Date"
                clearable
              />
            </Col>
          </Row>
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFControl name="hyConnectId" label="HY Connect ID" />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFDatePicker name="createdAt" label="Date Created" />
            </Col>
          </Row>
          <Row className="gx-3">
            <Col xs={12} sm={6} md={4}>
              <RHFControl
                name="language"
                label="Main Language"
                required
              />
            </Col>
            <Col xs={12} sm={6} md={4}>
              <RHFControl
                name="secondaryLanguage"
                label="Secondary Language"
              />
            </Col>
            <Col xs={12} sm={12} md={4}>
              <RHFControl name="address" label="Address" />
            </Col>
          </Row>
        </Container>
      </Card.Body>
    </Card>
  );
};

ProfileInformation.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string
};
